import React, { useState, useEffect } from 'react';
import Tabs, { Tab } from 'src/components/Tabs';
import { withRouter } from 'react-router-dom';
import { Header } from 'src/components/Header';
import { capitalize } from 'src/utils/string.utils';
import { gramsToKgsDisplay } from 'src/utils/misc.utils';
import styled, { css } from 'styled-components/macro';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import {
  faCamera, faCaretDown, faCaretUp, faChevronLeft, faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  SearchableDropdown,
} from 'src/components/SearchableDropdown';
import { accountingsActions } from 'src/store/accountings/accountings.actions';
import { useDispatch, useSelector } from 'react-redux';
import { getSlaughtersList, getAccountings as getAccountingsSelector } from 'src/store/accountings/accountings.selectors';
import { dateStrToNorwegianDateFormat, format } from 'src/utils/date.utils';
import { InfoBubble } from 'src/components/InfoBubble';
import LoadingIndicator from 'src/components/LoadingIndicator';
import { backendUrl } from 'src/config';
import Button from 'src/components/Button';
import { useToast } from 'src/components/Toast';
import Helptext from 'src/components/Helptext';
import { getBrandingColor, colorTypes } from 'src/branding';
import nb from 'date-fns/locale/nb';
import { getImpersonateParamIfSuperuser } from 'src/utils/routes.utils';
import Modal from 'src/components/Modal';

import { Breadcrumbs } from 'src/components/Breadcrumbs';
import { getFeaturesEnabled } from 'src/slaughterhouseSpecific';
import { formatAmount } from './util';
import {
  Animal, AnimalGroup, AnimalGroupHeader, PresentationRow, AnimalGroupInfo, LEDSheepExport, AnimalGroupToggleIcon, AccountingsWrapper,
  AnmialGroupInfoItem, DownloadPDFLink, ExportToExcelLink, StyledItemTable, SheepExportTable, SheepLedExportBtnWrapper, ContentWrapper, NextPrevIcon, SheepLedExportWrapper,
  PhotoIcon, DateDropdownItem, AnimalGroupTopPart, DatepickerLabel, SelectedDateFromBtn, DatePickerPopupWrapper,
} from './Components';
import { IconBadgeNumber } from '../Dashboard/Dashboard';
import { routes } from '../routes.manifest';
import {
  Page,
  LinkLabel,
  Row,
  Label,
} from '../../components/Layout';
import axiosInstance from 'src/axios-instance';
import { SeachableDropdownWrapper } from '../Documents/Components';

// Lists accountings for the user
// An accounting is a kind of receipt from a slaughter and can exist of multiple animals, but only one animal kind per accounting
const Accountings = ({ location: { pathname }, history: { push } }) => {
  const [animalGroupNamesOpen, setAnimalGroupNamesOpen] = useState([]);
  const tempAccountingsEnabled = getFeaturesEnabled().temp_accountings;
  const isStored = pathname === routes.accountingsPosted;
  const [showGroupLedSheepExport, setShowGroupSheepLedExport] = useState(false);

  const dispatch = useDispatch();
  const slaughtersList = useSelector(getSlaughtersList);
  const accountings = useSelector(getAccountingsSelector);

  // if selected with dropdown of accountings
  const [accountingKey, setAccountingKey] = useState('');

  // if selected with datepicker
  const [accountingDateFrom, setAccountingDateFrom] = useState();
  const [accountingDateTo, setAccountingDateTo] = useState();
  const [selectDateFromIsOpen, setSelectDateFromIsOpen] = useState(false);
  const [selectDateToIsOpen, setSelectDateToIsOpen] = useState(false);
  const [accountingDateFromMonth, setAccountingDateFromMonth] = useState();
  const [accountingDateToMonth, setAccountingDateToMonth] = useState();
  const [viewBy, setViewBy] = useState('byAccounting');

  const [acountingStatus, setAcountingStatus] = useState('');

  const [
    unreadPostedAccountingsCount,
    setUnreadPostedAccountingsCount,
  ] = useState(null);
  const [accountingsPostedLastRead, setAccountingsPostedLastRead] = useState(
    null,
  );

  const [carcassPhotoIds, setCarcassPhotoIds] = useState(null);
  const [currCarcassPhotoNotFound, setCurrCarcassPhotoNotFound] = useState(false);
  const [currCarcassPhotoIdx, setCurrCarcassPhotoIdx] = useState(0);
  const [currCarcassPhotoLoading, setCurrCarcassPhotoLoading] = useState(false);

  const formatDropdownLine = (d) => (isStored ? `${format(new Date(d.date), 'dd.MM.yyyy')} / ${
          d.settlement_no
      } / kr ${formatAmount(d.amount)}` : format(new Date(d.date), 'dd.MM.yyyy'));

  useEffect(() => {
    if (slaughtersList.postedSlaughters) {
      if (isStored) {
        axiosInstance.request({
          method: 'POST',
          url: `${backendUrl}/api/markread/accountings-posted/notification`,
          withCredentials: true,
        });
        setUnreadPostedAccountingsCount(null);
        setAccountingsPostedLastRead(null);
      }
    } else if (!slaughtersList.isFetchingPosted && !slaughtersList.error) {
      dispatch(accountingsActions.fetchPostedSlaughterList());
    }
    if (slaughtersList.tempSlaughters) {
      if (!isStored) {
        axiosInstance.request({
          method: 'POST',
          url: `${backendUrl}/api/markread/accountings-temp/notification`,
          withCredentials: true,
        });
        if (slaughtersList.postedSlaughters && accountingsPostedLastRead) {
          if (!accountingsPostedLastRead.timestamp) {
            setUnreadPostedAccountingsCount(
              slaughtersList.postedSlaughters.length,
            );
          } else {
            const date = new Date(accountingsPostedLastRead.timestamp);
            let unreadCount = 0;
            slaughtersList.postedSlaughters.map((slaughter) => {
              if (slaughter?.date && new Date(slaughter.date) > date) {
                unreadCount = unreadCount + 1;
              }
              return undefined;
            });
            setUnreadPostedAccountingsCount(unreadCount);
          }
        }
      }
    } else if (!slaughtersList.isFetchingTemp && !slaughtersList.error) {
      dispatch(accountingsActions.fetchTempSlaughterList());
    }
  }, [
    accountingsPostedLastRead,
    dispatch,
    isStored,
    slaughtersList.error,
    slaughtersList.isFetchingPosted,
    slaughtersList.isFetchingTemp,
    slaughtersList.postedSlaughters,
    slaughtersList.tempSlaughters,
  ]);

  // reset on tab change
  useEffect(() => {
    const isStored = pathname === routes.accountingsPosted;
    setAccountingKey('');
    setAnimalGroupNamesOpen([]);
    setAcountingStatus('');
  }, [pathname]);

  // load and select the first accounting
  useEffect(() => {
    if (
      isStored
      && !slaughtersList.isFetching
      && !slaughtersList.error
      && slaughtersList.postedSlaughters
      && slaughtersList.postedSlaughters.length > 0
      && !accountingKey
    ) {
      const firstDate = slaughtersList.postedSlaughters[0].date;
      const firstSettlementNo = slaughtersList.postedSlaughters[0].settlement_no;
      setAccountingKey(`${firstDate}/${firstSettlementNo}`);
      dispatch(accountingsActions.fetchPostedByDate({ date: firstDate, settlement_no: firstSettlementNo }));
    } else if (
      !isStored
      && !isStored.error
      && !slaughtersList.isFetching
      && !slaughtersList.error
      && slaughtersList.tempSlaughters
      && slaughtersList.tempSlaughters.length > 0
      && !accountingKey
    ) {
      const firstDate = slaughtersList.tempSlaughters[0].date;
      setAccountingKey(`${firstDate}`);
      dispatch(accountingsActions.fetchTempByDate({ date: firstDate }));
    }
  }, [
    accountingKey,
    dispatch,
    slaughtersList.isFetching,
    isStored,
    slaughtersList.postedSlaughters,
    slaughtersList.tempSlaughters,
    slaughtersList.error,
  ]);

  useEffect(() => {
    if (!isStored) {
      axiosInstance
        .request({
          method: 'GET',
          url: `${backendUrl}/api/hasread/accountings-posted/notification`,
          withCredentials: true,
        })
        .then(({ data }) => setAccountingsPostedLastRead(data));
    }
  }, [isStored]);

  const onClickAnimalGroup = (group) => {
    const groupAlreadyOpen = animalGroupNamesOpen.indexOf(group.group_name) >= 0;
    if (groupAlreadyOpen) {
      setAnimalGroupNamesOpen((animalGroupNamesOpen) => animalGroupNamesOpen.filter((g) => g !== group.group_name));
    } else {
      setAnimalGroupNamesOpen((animalGroupNamesOpen) => animalGroupNamesOpen.concat([group.group_name]));
    }
  };

  const selectedAccounting = isStored
    ? accountings.postedAccountings[accountingKey]
    : accountings.tempAccountings[accountingKey];

  const toast = useToast();

  // get loading/error status of either posted or temp accountings depanding in selected
  useEffect(() => {
    if (slaughtersList.isFetching) {
      setAcountingStatus('FETCHING');
    } else if (
      (isStored
        && slaughtersList.postedSlaughters
        && slaughtersList.postedSlaughters.length > 0)
      || (!isStored
        && slaughtersList.tempSlaughters
        && slaughtersList.tempSlaughters.length > 0)
    ) {
      setAcountingStatus('FOUND');
    } else if (
      (isStored
        && slaughtersList.postedSlaughters
        && slaughtersList.postedSlaughters.length === 0)
      || (!isStored
        && slaughtersList.tempSlaughters
        && slaughtersList.tempSlaughters.length === 0)
    ) {
      setAcountingStatus('NOT_FOUND');
    } else if (slaughtersList.error) {
      setAcountingStatus('ERROR');
    }
  }, [slaughtersList, isStored]);

  const getSlaughters = () => (isStored
    ? (slaughtersList.postedSlaughters && slaughtersList.postedSlaughters) || []
    : (slaughtersList.tempSlaughters && slaughtersList.tempSlaughters) || []);

  const getAccountings = () => (isStored ? accountings.postedAccountings : accountings.tempAccountings);

  const getSettlementNumber = (selectedAccounting) => (
    ((((selectedAccounting || {}).slaughter_animals_by_group || [])[0] || {})
      .animals || [])[0] || {}
  ).settlement_no;

  const hasPrevCarcassPhoto = carcassPhotoIds && currCarcassPhotoIdx > 0;
  const hasNextCarcassPhoto = carcassPhotoIds && currCarcassPhotoIdx + 1 < carcassPhotoIds.length;

  const gotoPrevCarcassPhoto = () => {
    if (!hasPrevCarcassPhoto) {
      return;
    }

    setCarcassImgLoadingIfNotCached(currCarcassPhotoIdx - 1);
    setCurrCarcassPhotoIdx((curr) => curr - 1);
    setCurrCarcassPhotoNotFound(false);
  };

  const gotoNextCarcassPhoto = () => {
    if (!hasNextCarcassPhoto) {
      return;
    }

    setCarcassImgLoadingIfNotCached(currCarcassPhotoIdx + 1);
    setCurrCarcassPhotoIdx((curr) => curr + 1);
    setCurrCarcassPhotoNotFound(false);
  };

  const setCarcassImgLoadingIfNotCached = (idx) => {
    const img = new Image();
    img.src = `${backendUrl}/api/slaughter_photo/${
                  isStored ? 'posted' : 'temp'
                }/${carcassPhotoIds[idx]}`;

    if (!img.complete) {
      setCurrCarcassPhotoLoading(true);
    }
  };

  const exportLEDSheepToClipboard = (group, accountingDate) => {
    let exportStr = '';
    for (const animal of group.animals) {
      exportStr += animal.description
        .toLowerCase()
        .includes('sau')
        ? ' Sau  '
        : ' Lam  ';
      exportStr += `${animal.classification}  `;
      exportStr += `${animal.individual_no}  `;
      exportStr += `${dateStrToNorwegianDateFormat(
        accountingDate,
      )}  `;
      exportStr += `${gramsToKgsDisplay(
        animal.weight_g,
      ).replace(',', '.')}  `;
      exportStr += `${animal.meat_fat_class}  `;
      exportStr += `${formatAmount(
        animal.price_kr_per_kg,
      )}  `;
      exportStr += `${formatAmount(animal.amount_kr)}`;
      exportStr += '\n';
    }

    const el = document.createElement('textarea');
    el.value = exportStr;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    toast.addMessage('Tekst kopiert');
  };

  const getAccountingDateObj = (accounting) => {
    const dateStr = accounting.date;
    return new Date(dateStr.split('-')[0], dateStr.split('-')[1] - 1, dateStr.split('-')[2]);
  };

  return (
    <AccountingsWrapper
      style={{
        width: '100%',
        display: 'flex',
        alignSelf: 'center',
        maxWidth: '1000px',
      }}
    >
      <Page
        title="Avregninger"
        style={{
          marginBottom: '5em',
          overflow: 'visible',
          width: 'fit-content',
          maxWidth: '900px',
          alignSelf: 'center',
          paddingLeft: '2em',
          paddingRight: '2em',
        }}
      >
        <Breadcrumbs
          breadcrumbs={[isStored ? { title: 'Bokførte avregninger', url: '/accountings' } : { title: 'Midlertidige avregninger', url: '/accountings/temp' },
          ]}
          wrapperStyle={css`
            margin-bottom: 0.6rem; `}
        />
        <Header>Avregninger</Header>

        <div style={{ width: 'fit-content' }}>
          {tempAccountingsEnabled
        && (
          <Tabs
            value={pathname}
            onChange={(tab) => {
              push(tab);
            }}
            style={{
              marginBottom: '1.5rem',
              position: 'relative',
              left: '-0.8rem',
              maxWidth: '36em',
            }}
          >
            <Tab style={{ whiteSpace: 'nowrap' }} value={routes.accountingsTemp}>Midl. avregninger</Tab>
            <Tab style={{ whiteSpace: 'nowrap' }} value={routes.accountingsPosted}>
              <>
                Bokførte avregninger
                {!!unreadPostedAccountingsCount && (
                  <IconBadgeNumber small>
                    {unreadPostedAccountingsCount > 9
                      ? '9+'
                      : unreadPostedAccountingsCount}
                  </IconBadgeNumber>
                )}
              </>
            </Tab>
          </Tabs>
        ) }
          {isStored
        && (
          <Tabs
            value={viewBy}
            onChange={(mode) => {
              setViewBy(mode);
            }}
            style={{
              position: 'relative',
              left: '-2.3rem',
              margin: '-0.6em auto 0.4em',
              width: 'fit-content',
            }}
          >
            <Tab style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }} value="byAccounting">Etter avregning</Tab>
            <Tab style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }} value="byDateRange">
              Etter dato-periode
            </Tab>
          </Tabs>
        )}
        </div>
        {acountingStatus === 'FETCHING' && (
          <LoadingIndicator
            withText
            style={{
              marginTop: '4.1em',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
        )}

        {acountingStatus === 'ERROR' && (
          <h2 style={{ marginTop: '3.7em' }}>
            Kunne ikke hente avregninger av valgt type
          </h2>
        )}
        {acountingStatus === 'NOT_FOUND' && (
          <h2 style={{ marginTop: '3.7em' }}>
            Fant ingen avregninger av valgt type
          </h2>
        )}

        {carcassPhotoIds && (
          <Modal closable onClose={() => setCarcassPhotoIds(null)} style={{ padding: carcassPhotoIds ? '2em 1.2em' : '2em' }}>
            {currCarcassPhotoLoading && currCarcassPhotoIdx.length > 1 && <p>Laster bilde...</p>}
            <img
              style={{ maxWidth: '100%', maxHeight: '90vh', minHeight: '100%' }}
              src={`${backendUrl}/api/slaughter_photo/${
                  isStored ? 'posted' : 'temp'
                }/${carcassPhotoIds[currCarcassPhotoIdx]}${getImpersonateParamIfSuperuser()}`}
              on
              onLoad={() => setCurrCarcassPhotoLoading(false)}
              onError={() => {
                setCurrCarcassPhotoNotFound(true);
                setCurrCarcassPhotoLoading(false);
              }}
              alt="Skrotbilde"
            />

            {carcassPhotoIds.length > 1 && !currCarcassPhotoNotFound
                && (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignSelf: 'center',
                    position: 'relative',
                    top: '1em',
                    fontSize: '1.05em',
                  }}
                  >
                    <NextPrevIcon
                      locked={!hasPrevCarcassPhoto}
                      hide={currCarcassPhotoLoading}
                      role="button"
                      icon={faChevronLeft}
                      onClick={gotoPrevCarcassPhoto}
                    />
                    {currCarcassPhotoLoading
                      ? <p style={{ margin: '0 1em', alignSelf: 'center' }}>Laster...</p>
                      : (
                        <p style={{ margin: '0 1em', alignSelf: 'center' }}>
                          Bilde
                          {currCarcassPhotoIdx + 1}
                          {' '}
                          av
                          {carcassPhotoIds.length}
                        </p>
                      )}
                    <NextPrevIcon
                      locked={!hasNextCarcassPhoto}
                      hide={currCarcassPhotoLoading}
                      role="button"
                      onClick={gotoNextCarcassPhoto}
                      icon={faChevronRight}
                      title="Neste bilde"
                    />
                  </div>
                )}

            {currCarcassPhotoNotFound && (
              <p>Bildet eksisterer ikke, eller kunne ikke lastes inn.</p>
            )}
          </Modal>
        )}

        {viewBy === 'byAccounting'
        && (
          <>
            <div
              style={{
                marginBottom: '5px',
                display: 'flex',
              }}
            >
              {acountingStatus === 'FOUND' && (
                <Label
                  color={getBrandingColor(colorTypes.fontHeader)}
                  marginBottom="0.2rem"
                  marginTop="1.5em"
                >
                  {isStored ? 'Bokførte avregninger' : 'Midlertidige avregninger'}
                </Label>
              )}

              {acountingStatus === 'FOUND' && (
                <Helptext
                  name={isStored ? 'search-accountings-stored' : 'search-accountings-temp'}
                  render={(text) => text && (
                    <InfoBubble
                      ariaLabel="Informasjon om hva som kan søkes etter i søkeboks for dato"
                      topModal="18px"
                      leftModal="-60px"
                      popupStyle={{ position: 'absolute' }}
                      style={{
                        alignSelf: 'flex-end',
                        height: 'fit-content',
                        marginLeft: '0.4em',
                        position: 'relative',
                        marginBottom: '2px',
                      }}
                    >
                      <p>{text}</p>
                    </InfoBubble>
                  )}
                />
              )}

            </div>

            <ContentWrapper isLoading={acountingStatus === 'FETCHING'}>
              {acountingStatus === 'FOUND' && selectedAccounting && (
                <div style={{ position: 'relative' }}>

                  <SeachableDropdownWrapper>
                    <SearchableDropdown
                      placeholder="Søk etter avregning"
                      itemSearchKey="formatted"
                      disabled={!selectedAccounting}
                      smallScreenwidth="95%"
                      bigScreenWidth="430px"
                      bigScreenWidthResultList="430"
                      smallScreenWidthResultList="95%"
                      initialValue={
                      `${dateStrToNorwegianDateFormat(getSlaughters()[0].date)
                      } ( nyeste avregning) `
                    }
                      selectedItem={getSlaughters()
                        .map((d) => ({
                          date: d.date,
                          settlement_no: d.settlement_no,
                          formatted: formatDropdownLine(d),
                        }))
                        .find((e) => (isStored ? `${e.date}/${e.settlement_no}` : e.date) === accountingKey)}
                      renderSelectedItemInInput={(item) => (item.date === getSlaughters()[0]
                        ? `${item.formatted} (nyeste avregning)`
                        : item.formatted)}
                      renderItem={(item, searchTerm, itemHasFocus) => (
                        <DateDropdownItem
                          smallFontOnSmallScreens
                          key={searchTerm}
                          searchTerm={searchTerm}
                          itemHasFocus={itemHasFocus}
                          item={item}
                          fontSize="0.9em"
                        />
                      )}
                      dataitems={getSlaughters().map((d) => ({
                        date: d.date,
                        settlement_no: d.settlement_no,
                        formatted: formatDropdownLine(d),
                      }))}
                      onSelectedChange={(item) => {
                        if (!item) {
                          return;
                        }
                        if (isStored) {
                          setAccountingKey(`${item.date}/${item.settlement_no}`);
                        } else {
                          setAccountingKey(`${item.date}`);
                        }
                        if (!getAccountings()[`${item.date}/${item.settlement_no}`] || !isStored) {
                          dispatch(
                            isStored
                              ? accountingsActions.fetchPostedByDate({
                                date: item.date,
                                settlement_no: item.settlement_no,
                              })
                              : accountingsActions.fetchTempByDate({
                                date: item.date,
                                settlement_no: item.settlement_no,
                              }),
                          );
                        }
                      }}
                    />
                  </SeachableDropdownWrapper>

                  <ExportToExcelLink
                    style={{
                      height: '1.2rem',
                      boxSizing: 'border-box',
                      display: 'inline-block',
                      marginTop: '0.6em',
                    }}
                    small
                    href={`${backendUrl}/api/${
                  isStored
                    ? 'posted_slaughter_by_date'
                    : 'temp_slaughter_by_date'
                }/${accountingKey.split('/')[0]}/export/excel?settlement_no=${accountingKey.split('/')[1]}${getImpersonateParamIfSuperuser(false)}`}
                  >
                    Eksporter til Excel
                  </ExportToExcelLink>
                  {acountingStatus === 'FOUND'
                && isStored
                && selectedAccounting
                && selectedAccounting.has_document
                && getSettlementNumber(selectedAccounting) && (
                  <DownloadPDFLink
                    small
                    download
                    style={{
                      height: '1.2rem',
                      boxSizing: 'border-box',
                      display: 'inline-block',
                      marginTop: '0.6em',
                      marginLeft: '3%',
                    }}
                    href={`${backendUrl}/api/documents/download/accounting/${getSettlementNumber(
                      selectedAccounting,
                    )}${getImpersonateParamIfSuperuser(
                      false,
                    )}`}
                  >
                    Hent PDF for avregning nr
                    {' '}
                    {getSettlementNumber(
                      selectedAccounting,
                    )}
                  </DownloadPDFLink>
                  )}
                </div>
              )}

              {selectedAccounting
            && selectedAccounting.slaughter_animals_by_group.map((group) => (
              <AnimalGroup>
                <AnimalGroupTopPart onClick={() => onClickAnimalGroup(group)}>
                  <AnimalGroupHeader primary>
                    {capitalize(group.group_name)}
                    {' '}
                    (
                    {group.animals.length}
                    {' '}
                    dyr)
                  </AnimalGroupHeader>
                  <AnimalGroupToggleIcon
                    icon={
                      animalGroupNamesOpen.indexOf(group.group_name) >= 0
                        ? faCaretUp
                        : faCaretDown
                    }
                  />
                </AnimalGroupTopPart>
                <AnimalGroupInfo
                  open={animalGroupNamesOpen.indexOf(group.group_name) >= 0}
                >
                  <Row width="50%" name="groupStatsRow1">
                    <AnmialGroupInfoItem>
                      <span
                        style={{ fontWeight: '600', marginBottom: '0.1rem' }}
                      >
                        Gjennomsnitt vekt
                      </span>
                      <span>
                        {gramsToKgsDisplay(group.avg_weight_g)}
                        {' '}
                        kg
                      </span>
                    </AnmialGroupInfoItem>
                    <AnmialGroupInfoItem>
                      <span
                        style={{ fontWeight: '600', marginBottom: '0.1rem' }}
                      >
                        Total vekt
                      </span>
                      <span>
                        {gramsToKgsDisplay(group.tot_weight_g)}
                        {' '}
                        kg
                      </span>
                    </AnmialGroupInfoItem>
                  </Row>
                  <Row marginTop="1rem">
                    <AnmialGroupInfoItem>
                      <span
                        style={{ fontWeight: '600', marginBottom: '0.1rem' }}
                      >
                        Anmerkninger
                      </span>
                      <div>
                        {group.diseases.map((d) => (
                          <span style={{ display: 'block' }}>
                            {capitalize(d.name)}
                            {' '}
                            (
                            {d.count}
                            {' '}
                            dyr)
                          </span>
                        ))}
                      </div>
                    </AnmialGroupInfoItem>
                  </Row>
                </AnimalGroupInfo>
                {animalGroupNamesOpen.indexOf(group.group_name) >= 0 && (
                  <LEDSheepExport>
                    {group.animals.find(
                      (a) => a.description.toLowerCase().includes('lam')
                        || a.description.toLowerCase().includes('sau'),
                    ) && (
                      <SheepLedExportBtnWrapper>
                        <LinkLabel
                          onClick={() => setShowGroupSheepLedExport(group.group_name)}
                          style={{
                            display: 'inline-block',
                            marginRight: 'auto',
                            height: '1.2rem',
                            boxSizing: 'border-box',
                          }}
                          small
                        >
                          Eksporter til LED-sau
                        </LinkLabel>
                      </SheepLedExportBtnWrapper>
                    )}
                  </LEDSheepExport>
                )}
                {animalGroupNamesOpen.indexOf(group.group_name) >= 0
                  && group.animals.map((animal) => (
                    <Animal>
                      <PresentationRow>
                        <StyledItemTable>
                          <tbody>
                            <tr>
                              <td>Merkenr/individnr</td>
                              <td style={{ display: 'flex' }}>
                                {animal.mark_no || animal.individual_no
                                  ? `${animal.mark_no} / ${animal.individual_no}`
                                  : ''}
                                {animal.slaughter_image_download_ids
                                && animal.slaughter_image_download_ids.length > 0 && (
                                  <PhotoIcon
                                    icon={faCamera}
                                    title="Skrottbilde"
                                    onClick={() => {
                                      setCarcassPhotoIds(
                                        animal.slaughter_image_download_ids,
                                      );
                                      setCurrCarcassPhotoNotFound(false);
                                      setCurrCarcassPhotoLoading(true);
                                      setCurrCarcassPhotoIdx(0);
                                    }}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>Vare (kl, fett/kjøtt %)</td>
                              <td>
                                {animal.description}
                                {' '}
                                (
                                {animal.classification}
                                ,
                                {' '}
                                {animal.description
                                  .toLowerCase()
                                  .includes('gris')
                                || animal.description
                                  .toLowerCase()
                                  .includes('purke')
                                || animal.description
                                  .toLowerCase()
                                  .includes('råne')
                                  ? `${animal.meat_percent}%`
                                  : animal.meat_fat_class}
                                )
                              </td>
                            </tr>
                            <tr>
                              <td>Vekt</td>
                              <td>
                                {gramsToKgsDisplay(animal.weight_g)}
                                {' '}
                                kg
                              </td>
                            </tr>
                            <tr>
                              <td>Anmerkninger</td>
                              <td>
                                {animal.diseases.map((d) => d.name).join(', ')}
                              </td>
                            </tr>
                            {isStored && (
                              <>
                                <tr>
                                  <td>Basispris pr kg</td>
                                  <td>
                                    {formatAmount(animal.price_kr_per_kg)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Beløp</td>
                                  <td>{formatAmount(animal.amount_kr)}</td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </StyledItemTable>
                      </PresentationRow>
                    </Animal>
                  ))}

                {showGroupLedSheepExport === group.group_name && (
                  <SheepLedExportWrapper>
                    <SheepExportTable>
                      <thead>
                        <th>Dyreart</th>
                        <th>Kl.</th>
                        <th>Ind.nr</th>
                        <th>Dato</th>
                        <th>Vekt</th>
                        <th>Fettgr/Kj%</th>
                        <th>Pris</th>
                        <th>Beløp</th>
                      </thead>

                      <tbody>
                        {group.animals.map((animal) => (
                          <tr>
                            <td>
                              {animal.description.toLowerCase().includes('sau')
                                ? 'Sau'
                                : 'Lam'}
                            </td>
                            <td>{animal.classification}</td>
                            <td>{animal.individual_no}</td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                              {dateStrToNorwegianDateFormat(accountingKey.split('/')[0])}
                            </td>
                            <td>
                              {gramsToKgsDisplay(animal.weight_g).replace(
                                ',',
                                '.',
                              )}
                            </td>
                            <td>{animal.meat_fat_class}</td>
                            <td>{formatAmount(animal.price_kr_per_kg)}</td>
                            <td>{formatAmount(animal.amount_kr)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </SheepExportTable>
                    <div
                      style={{
                        left: '50%',
                        position: 'relative',
                        transform: 'translateX(-8%)',
                        marginTop: '1.5em',
                      }}
                    >
                      <Button
                        primary
                        style={{ marginRight: '1em' }}
                        onClick={() => exportLEDSheepToClipboard(group, accountingKey.split('/')[0])}
                      >
                        Kopier til utklipstavle
                      </Button>
                      <Button
                        secondary
                        onClick={() => setShowGroupSheepLedExport((old) => !old)}
                      >
                        Lukk
                      </Button>
                    </div>
                  </SheepLedExportWrapper>
                )}
              </AnimalGroup>
            ))}

              {!selectedAccounting
            && acountingStatus !== 'NOT_FOUND'
            && acountingStatus !== 'ERROR' && <h2>Laster ...</h2>}
            </ContentWrapper>
          </>
        )}

        {viewBy === 'byDateRange'
      && isStored && acountingStatus === 'FOUND' && (
        <>
          {selectDateFromIsOpen
                && (
                  <Modal className="select-date-modal">
                    <DayPicker
                      mode="single"
                      onSelect={(val) => { if (val) { setAccountingDateFrom(val); } setSelectDateFromIsOpen(false); }}
                      locale={nb}
                      selected={accountingDateFrom}
                      toDate={getAccountingDateObj(Object.values(slaughtersList.postedSlaughters)[0])}
                      fromDate={getAccountingDateObj(Object.values(slaughtersList.postedSlaughters).slice(-1)[0])}
                      month={accountingDateFromMonth}
                      onMonthChange={setAccountingDateFromMonth}
                    />
                  </Modal>
                )}

          {selectDateToIsOpen
                && (
                  <Modal className="select-date-modal">
                    <DayPicker
                      mode="single"
                      onSelect={(val) => { if (val) { setAccountingDateTo(val); } setSelectDateToIsOpen(false); }}
                      locale={nb}
                      selected={accountingDateTo}
                      toDate={getAccountingDateObj(Object.values(slaughtersList.postedSlaughters)[0])}
                      fromDate={getAccountingDateObj(Object.values(slaughtersList.postedSlaughters).slice(-1)[0])}
                      month={accountingDateToMonth}
                      onMonthChange={setAccountingDateToMonth}
                    />
                  </Modal>
                )}

          <DatepickerLabel style={{ marginTop: '1em', marginBottom: '0.5em' }}>
            Hent avregninger
          </DatepickerLabel>
          <div style={{ display: 'flex' }}>
            <SelectedDateFromBtn onClick={() => { setSelectDateFromIsOpen((old) => !old); setSelectDateToIsOpen(false); }}>
              {accountingDateFrom
                ? `Fra: ${format(accountingDateFrom, 'dd.MM.y')}`
                : 'Fra: Ikke satt' }
            </SelectedDateFromBtn>

            <SelectedDateFromBtn onClick={() => { setSelectDateToIsOpen((old) => !old); setSelectDateFromIsOpen(false); }}>
              {accountingDateTo
                ? `Til: ${format(accountingDateTo, 'dd.MM.y')}`
                : 'Til: Ikke satt'}
            </SelectedDateFromBtn>
          </div>
          {(accountingDateFrom && accountingDateTo && accountingDateFrom > accountingDateTo
          && <Label marginTop="1.1em" color={getBrandingColor(colorTypes.error)}>Fra-dato kan ikke være større enn til-dato</Label>)
          || (accountingDateFrom && accountingDateTo
                 && (
                   <ExportToExcelLink
                     style={{
                       height: '1.2rem',
                       boxSizing: 'border-box',
                       display: 'inline-block',
                       marginTop: '0.6em',
                     }}
                     small
                     href={`${backendUrl}/api/posted_slaughter_by_date_range/${format(accountingDateFrom, 'yyyy-MM-dd')}/${format(accountingDateTo, 'yyyy-MM-dd')}/export/excel${getImpersonateParamIfSuperuser()}`}
                   >
                     Eksporter til Excel
                   </ExportToExcelLink>
                 ))}

        </>
        )}
      </Page>
    </AccountingsWrapper>
  );
};

export default withRouter(Accountings);
